module.exports = __webpack_public_path__ + "media/images/kaoawase/hall-list/kaoawase-halllist-6-a55f7f52cbc3aa5b83b9de265eba9085.png";